import React from "react";
import "../styles/Footer.css";
import appstore from "../assets/images/appstore-apple.svg"
import playstore from "../assets/images/appstore-android.svg"

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          {/* Download App Section */}
          <div className="col col-left">
            <h3 className="title">GET THE APP</h3>
            <p className="subtitle">
              Download our Industrial Machine Monitoring App and manage users, devices, and machines
              anytime, anywhere. Available on Android and iOS.
            </p>

            <ul className="app-buttons">
              <li>
                <a
                  href="https://apps.apple.com/pl/app/supermanager-flovation/id6469298141"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={appstore} alt="App Store" />
                </a>
              </li>
              <li>
                <a
                  href="https://play.google.com/store/apps/details?id=com.i9930.react.flovation&pcampaignid=web_share"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={playstore} alt="Google Play" />
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div className="col">
            <h4 className="col-heading">Legal</h4>
            <ul className="footer-list">
              <li><a href="">Privacy</a></li>
              <li><a href="">Terms of Service</a></li>
              <li><a href="">Security</a></li>
            </ul>
          </div>

          {/* Stay Connected */}
          <div className="col">
            <h4 className="col-heading">Stay Connected</h4>
            <ul className="social-list">
              <li><a href="mailto:Info@flovation.in"><i className="fa fa-envelope-square"></i></a></li>
              <li><a href="https://www.linkedin.com/company/supermanager-india"><i className="fa fa-linkedin-square"></i></a></li>
              {/* <li><a href=""><i className="fa fa-twitter"></i></a></li> */}
            </ul>

            <div className="address">
              Flovation Technologies Pvt. Ltd. <br />
              107, 9930 Spaces, Mangal Nagar <br />
              Indore [MP] <br />
            </div>

            <div className="email">
              <a href="mailto:Info@flovation.in">Info@flovation.in</a>
            </div>
          </div>
        </div>
      </div>

      <h6 className="footer-bottom">
        &copy; Powered by Flovation Technologies Private Limited
      </h6>
    </footer>
  );
}
